function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7119 5.57143V7.17857C19.7119 8.59487 16.1931 9.75 11.8559 9.75C7.51879 9.75 4 8.59487 4 7.17857V5.57143C4 4.15513 7.51879 3 11.8559 3C16.1931 3 19.7119 4.15513 19.7119 5.57143ZM19.7119 9.1875V12.8036C19.7119 14.2199 16.1931 15.375 11.8559 15.375C7.51879 15.375 4 14.2199 4 12.8036V9.1875C5.6878 10.3527 8.77697 10.8951 11.8559 10.8951C14.9349 10.8951 18.024 10.3527 19.7119 9.1875ZM19.7119 14.8125V18.4286C19.7119 19.8449 16.1931 21 11.8559 21C7.51879 21 4 19.8449 4 18.4286V14.8125C5.6878 15.9777 8.77697 16.5201 11.8559 16.5201C14.9349 16.5201 18.024 15.9777 19.7119 14.8125Z",
  fill: "#424240"
});

var SvgData = function SvgData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Data.b1c3b5f8.svg";
export { ForwardRef as ReactComponent };